import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@mui/material";
import InputTextField from "../../../../components/input/inputTextField";
import { NavigateFunction, useNavigate, useParams } from "react-router-dom";
import NavigateListCustom from "../../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../../routes/routeName";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../../components/button/ButtonCustoms";
import UploadFile from "../../../../components/upload/UploadFile";
import { useTranslation } from "react-i18next";
import { advisorRequestApi } from "../../../../api/advisor-request/advisor-request.api";
import {
  alertActive,
  alertError,
  alertSuccess,
} from "../../../../components/alert/swal";
import { useDispatch } from "react-redux";
import {
  setLoading,
  unsetLoading,
} from "../../../../store/loading/loading.slice";
import CustomStatus from "../../../../components/chip/CustomStatus";
import { FiberManualRecord } from "@mui/icons-material";
import ModalRejectAdvisorRequest from "../components/ModalRejectAdvisorRequest";
import DetailCard from "../../../../components/card/DetailCard";
import { getFileExtension } from "../../../../utils/fileTypeDownload";
import { saveAs } from "file-saver";

const AdvisorRequestDetail = () => {
  const { t } = useTranslation();
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const [inputValue, setInputValue] = useState<any>({});
  const [isOpenModalReject, setIsOpenModalReject] = useState<boolean>(false);
  const [inputComment, setInputComment] = useState<string>("");
  const [dataTransfer, setDataTransfer] = useState<any>({});

  const fetchGetAdvisorRequestById = async (id: number) => {
    const res = await advisorRequestApi.getSingleAdvisorRequestById(id);
    const data = res.data;
    if (data.status < 300) {
      setInputValue(data.data);
    } else {
      setInputValue({});
    }
  };

  useEffect(() => {
    if (id) {
      fetchGetAdvisorRequestById(parseInt(id));
    }
  }, [id]);

  const fetchGetAdvisorTransferById = async (id: number) => {
    const res = await advisorRequestApi.getSingleAdvisorTransferById(id);
    const data = res.data;
    if (data.status < 300) {
      setDataTransfer(data.data);
    } else {
      setDataTransfer({});
    }
  };

  useEffect(() => {
    if (id) {
      fetchGetAdvisorRequestById(+id);
      fetchGetAdvisorTransferById(+id);
    }
  }, [id]);

  const handleApproveRequest = async (id: number, status: string) => {
    if (id) {
      const title =
        status === "อนุมัติ"
          ? "ตอบรับคำร้องขอให้เป็นที่ปรึกษาวิทยานิพนธ์"
          : "สิ้นสุดการเป็นอาจารย์ที่ปรึกษา";
      const subTitle =
        status === "อนุมัติ"
          ? "ท่านต้องการตอบรับคำร้องขอให้เป็นที่ปรึกษา ใช่หรือไม่"
          : "ท่านต้องการสิ้นสุดการเป็นอาจารย์ที่ปรึกษา ใช่หรือไม่";
      const titleResult =
        status === "อนุมัติ"
          ? "ตอบรับคำร้องขอให้เป็นที่ปรึกษาวิทยานิพนธ์"
          : "สิ้นสุดการเป็นอาจารย์ที่ปรึกษา";
      const subTitleResult =
        status === "อนุมัติ"
          ? "ตอบรับคำร้องขอให้เป็นที่ปรึกษา เรียบร้อยแล้ว"
          : "สิ้นสุดการเป็นอาจารย์ที่ปรึกษา เรียบร้อยแล้ว";
      const errorMessage =
        status === "อนุมัติ"
          ? "ตอบรับคำร้องขอให้เป็นที่ปรึกษาวิทยานิพนธ์ ไม่สำเร็จ"
          : "สิ้นสุดการเป็นอาจารย์ที่ปรึกษา ไม่สำเร็จ";

      alertActive(title, subTitle, undefined, undefined, async () => {
        dispatch(setLoading());
        await advisorRequestApi
          .updateStatusAdvisorRequest(+id, status, "")
          .then((res) => {
            if (res.status < 300) {
              alertSuccess(titleResult, subTitleResult, undefined, () => {
                // navigate(routeName.advisor.manageAdvisorRequest);
                fetchGetAdvisorRequestById(id);
              });
            }
          })
          .catch(() => {
            alertError(errorMessage);
          })
          .finally(() => {
            dispatch(unsetLoading());
          });
      });
    }
    return;
  };

  const handleRejectRequest = async (
    id: number,
    status: string,
    comment: string
  ) => {
    if (id && comment) {
      await advisorRequestApi
        .updateStatusAdvisorRequest(+id, status, comment ?? "")
        .then((res) => {
          if (res.status < 300) {
            alertSuccess(
              "ปฏิเสธคำร้องขอให้เป็นที่ปรึกษาวิทยานิพนธ์",
              "ปฏิเสธคำร้องขอให้เป็นที่ปรึกษา เรียบร้อยแล้ว",
              undefined,
              () => {
                fetchGetAdvisorRequestById(id);
                setIsOpenModalReject(false);
                setInputComment("");
              }
            );
          }
        })
        .catch(() => {
          alertError("ปฏิเสธคำร้องขอให้เป็นที่ปรึกษาวิทยานิพนธ์ ไม่สำเร็จ");
        })
        .finally(() => {
          dispatch(unsetLoading());
        });
    } else {
      alertError("ข้อมูลไม่ครบถ้วน กรุณาตรวจสอบอีกครั้ง");
    }
    return;
  };

  const handleDownloadFile = async (id: number, name_file: string) => {
    dispatch(setLoading());
    await advisorRequestApi
      .downloadFileRequest(id)
      .then((res) => {
        if (res.status < 300) {
          const response = res.data;

          // Get the content type from the server's response headers
          const contentType = res.headers["content-type"];

          // Create a Blob with the content type from the response
          const blob = new Blob([response], { type: contentType });

          // Extract file extension based on content type
          const fileExtension = getFileExtension(contentType || "");

          // Generate a filename with the correct extension (you can also modify this to use a custom name)
          const fileName = `${name_file}.${fileExtension}`;

          // Save the file
          saveAs(blob, fileName);
        }
      })
      .catch((error) => console.log(error))
      .finally(() => dispatch(unsetLoading()));
  };

  const handleColorStatus = (status_type: string) => {
    if (status_type === "draft") {
      return "default";
    } else if (status_type === "รอพิจารณา") {
      return "warning";
    } else if (status_type === "ตอบรับเป็นที่ปรึกษา") {
      return "success";
    } else if (status_type === "ปฏิเสธคำขอ") {
      return "error";
    } else if (status_type === "รออาจารย์ที่ปรึกษาพิจารณาคำร้อง") {
      return "warning";
    } else if (status_type === "รออาจารย์ที่ปรึกษาใหม่พิจารณาคำร้อง") {
      return "warning";
    } else if (status_type === "อนุมัติคำร้องขอเปลี่ยนอาจารย์ที่ปรึกษา") {
      return "info";
    } else if (status_type === "อาจารย์ที่ปรึกษาไม่อนุมัติ") {
      return "error";
    } else if (status_type === "อาจารย์ที่ปรึกษาใหม่ปฏิเสธคำขอ") {
      return "error";
    } else {
      return "warning";
    }
  };

  return (
    <div className="h-auto">
      <ModalRejectAdvisorRequest
        setIsOpenModal={(isOpen: boolean) => setIsOpenModalReject(isOpen)}
        isOpenModal={isOpenModalReject}
        onSubmit={() => {
          if (id && inputComment) {
            handleRejectRequest(parseInt(id), "ไม่อนุมัติ", inputComment);
          }
        }}
        inputComment={inputComment}
        setInputComment={(value: string) => setInputComment(value)}
      />

      <NavigateListCustom
        navigateData={[
          {
            name: "ระบบ Advisor",
            key: "1",
            pathName: routeName.advisor.manageAdvisorRequest,
          },
          {
            name: "ข้อมูลคำร้อง",
            key: "2",
            pathName: routeName.advisor.manageAdvisorRequest + "/" + id,
          },
        ]}
      />

      {/* header */}
      <section className="my-4 flex justify-between">
        <Typography variant="h3">
          ข้อมูลคำร้อง{" "}
          <CustomStatus
            label={inputValue && inputValue.status_request}
            type="outlined"
            color={handleColorStatus(inputValue?.status_request ?? "")}
            icon={<FiberManualRecord />}
          />{" "}
          {(inputValue && inputValue.status_request === "ปฏิเสธคำขอ") ||
          inputValue.status_request === "อาจารย์ที่ปรึกษาใหม่ปฏิเสธคำขอ" ? (
            <span style={{ color: "red", fontSize: "14px" }}>
              หมายเหตุ : {inputValue.advisor_refuse}
            </span>
          ) : null}
        </Typography>

        {(inputValue && inputValue.status_request === "รอพิจารณา") ||
        inputValue.status_request === "รออาจารย์ที่ปรึกษาพิจารณาคำร้อง" ||
        inputValue.status_request === "รออาจารย์ที่ปรึกษาใหม่พิจารณาคำร้อง" ? (
          <div>
            <ButtonOutlined
              onClick={() => {
                navigate(routeName.advisor.manageAdvisorRequest);
              }}
              mode="del"
              buttonName="ย้อนกลับ"
              btnProps={{
                width: "125px",
              }}
            />

            <ButtonPrimary
              onClick={() => {
                if (id) {
                  handleApproveRequest(parseInt(id), "อนุมัติ");
                }
              }}
              mode={"done"}
              buttonName={"ตอบรับ"}
              btnProps={{
                width: "125px",
                margin: "0 10px 0 10px",
              }}
            />

            <ButtonPrimary
              onClick={() => {
                setIsOpenModalReject(true);
              }}
              mode={"cancel"}
              buttonName={"ปฏิเสธ"}
              btnProps={{
                width: "125px",
              }}
            />
          </div>
        ) : null}
      </section>

      <Grid container spacing={2} alignItems="starts">
        <Grid item xs={12} sm={3.5}>
          <Typography variant="subtitle1">
            ชื่อ - นามสกุล :{" "}
            {(inputValue &&
              inputValue.student_frist_name +
                " " +
                inputValue.student_last_name) ??
              ""}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2}>
          <Typography variant="subtitle1">
            ฉายา : {(inputValue && inputValue.student_middle_name) ?? ""}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography variant="subtitle1">
            รหัสประจำตัวนักศึกษา : {(inputValue && inputValue.student_no) ?? ""}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={1}>
          <Typography variant="subtitle1">
            ชั้นปีที่ : {(inputValue && inputValue.grade_level) ?? ""}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2.5}>
          <Typography variant="subtitle1">
            หลักสูตร : {(inputValue && inputValue.faculty_name) ?? ""}
          </Typography>
        </Grid>
      </Grid>

      {inputValue.status_request === "รออาจารย์ที่ปรึกษาพิจารณาคำร้อง" ||
      inputValue.status_request === "รออาจารย์ที่ปรึกษาใหม่พิจารณาคำร้อง" ? (
        <>
          <section className="w-full mb-12 mt-24">
            <Grid container spacing={2}>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{
                  alignSelf: "end",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <DetailCard
                  fullname={
                    dataTransfer?.old_advisor?.first_name +
                    " " +
                    dataTransfer?.old_advisor?.last_name
                  }
                  email={dataTransfer?.old_advisor?.email_organization ?? ""}
                  maxStudents={dataTransfer?.old_advisor?.number_students ?? ""}
                  requestCount={dataTransfer?.old_advisor?.count_req_all ?? ""}
                  advisorCount={dataTransfer?.old_advisor?.count_req ?? ""}
                  isSelect={false}
                  status={"transfer_1"}
                  setIsShowModalSendRequest={() => {}}
                  remark={""}
                  degree={dataTransfer?.old_advisor?.degree ?? ""}
                  faculty={dataTransfer?.old_advisor?.faculty ?? ""}
                  year={dataTransfer?.old_advisor?.year ?? ""}
                  classRoom={dataTransfer?.old_advisor?.classRoom ?? ""}
                  onCancelRequest={() => {}}
                  image={dataTransfer?.old_advisor?.file_path ?? ""}
                  isTransfer={true}
                />
                <section className="px-4">
                  <ButtonPrimary
                    onClick={() => {}}
                    mode={"transfer"}
                    buttonName={""}
                    btnProps={{
                      padding: "10px 0px 10px 10px",
                    }}
                  />
                </section>

                <DetailCard
                  fullname={
                    dataTransfer?.new_advisor?.first_name +
                    " " +
                    dataTransfer?.new_advisor?.last_name
                  }
                  email={dataTransfer?.new_advisor?.email_organization ?? ""}
                  maxStudents={dataTransfer?.new_advisor?.number_students ?? ""}
                  requestCount={dataTransfer?.new_advisor?.count_req_all ?? ""}
                  advisorCount={dataTransfer?.new_advisor?.count_req ?? ""}
                  isSelect={false}
                  status={"transfer_2"}
                  setIsShowModalSendRequest={() => {}}
                  remark={""}
                  degree={dataTransfer?.new_advisor?.degree ?? ""}
                  faculty={dataTransfer?.new_advisor?.faculty ?? ""}
                  year={dataTransfer?.new_advisor?.year ?? ""}
                  classRoom={dataTransfer?.new_advisor?.classRoom ?? ""}
                  onCancelRequest={() => {}}
                  image={dataTransfer?.new_advisor?.file_path ?? ""}
                  isTransfer={true}
                />
              </Grid>
            </Grid>
          </section>

          <section className="my-4">
            <InputTextField
              heading={"เหตุผลจากนักศึกษา"}
              placeholder={"เหตุผลจากนักศึกษา"}
              value={dataTransfer?.advisor_reason ?? ""}
              disabled={true}
              row={3}
              maxRows={5}
              disablePaddingMultiline
              multiline
              inputHeight={"auto"}
            />
          </section>
        </>
      ) : (
        <>
          <section className="mt-12">
            <InputTextField
              heading={"ชื่อวิทยานิพนธ์"}
              placeholder={"ชื่อวิทยานิพนธ์"}
              value={inputValue?.advisor_request_name ?? ""}
              disabled={true}
            />
          </section>

          <section className="my-4">
            <InputTextField
              heading={"รายละเอียด"}
              placeholder={"รายละเอียด"}
              value={inputValue?.advisor_request_desc ?? ""}
              disabled={true}
              row={3}
              maxRows={5}
              disablePaddingMultiline
              multiline
              inputHeight={"auto"}
            />
          </section>

          <section className="my-4">
            <UploadFile
              fileAttachmentId={inputValue?.file_name ?? ""}
              fileAttachmentName={inputValue?.file_name ?? ""}
              noClick={true}
              onDeleteFile={() => {}}
              onDrop={() => {}}
              // file={inputValue?.file_path ? `${inputValue?.file_path}` : ""}
              formatText={t("FILE_UPLOAD.FILE_SIZE")}
              disableDeleteFileId={true}
              onDeleteFileId={() => {}}
              hiddenDownloadFile={false}
              onDownloadFile={() => {
                handleDownloadFile(
                  inputValue?.id_advisor_request,
                  inputValue?.file_name
                );
              }}
            />
          </section>
        </>
      )}

      <section className="my-4 flex justify-center">
        {inputValue &&
        inputValue.status_request !== "รอพิจารณา" &&
        inputValue.status_request !== "รออาจารย์ที่ปรึกษาพิจารณาคำร้อง" ? (
          <ButtonOutlined
            onClick={() => {
              navigate(routeName.advisor.manageAdvisorRequest);
            }}
            mode="del"
            buttonName="ย้อนกลับ"
            btnProps={{
              width: "125px",
            }}
          />
        ) : null}

        {inputValue && inputValue.status_request === "ตอบรับเป็นที่ปรึกษา" ? (
          <ButtonPrimary
            onClick={() => {
              if (id) {
                handleApproveRequest(parseInt(id), "สิ้นสุดการปรึกษา");
              }
            }}
            mode={"cancel"}
            buttonName={"สิ้นสุดการเป็นอาจารย์ที่ปรึกษา"}
            btnProps={{
              width: "250px",
              margin: "0 10px 0 10px",
            }}
          />
        ) : null}
      </section>
    </div>
  );
};

export default AdvisorRequestDetail;
